import { FunctionComponent } from 'react';
import { NoValue } from '../../../sharedComponents/NoValue';
import { LabelledInfoCell } from '../../../sharedComponents/sidebar/LabelledInfoCell';
import { CompoundLocation, Departure } from '../../compoundManagement.types';
import { DisplayCancellableData } from '../../shared/dataDisplay/DisplayCancellableData';
import { DepartureCompletedForm } from '../../shared/sidebar/DepartureCompletedForm';
import { DetailsRow } from '../../shared/sidebar/DetailsRow';
import { AddressDetails } from '../../../sharedComponents/AddressDetails';
import { DisplayDepartureFreightForwarder } from '../../shared/dataDisplay/DepartureDataContent';

export type DepartureDetailsProps = {
    compoundVehicleId: string;
    departure: Departure;
    compoundLocation: CompoundLocation;
};

export const DepartureDetails: FunctionComponent<DepartureDetailsProps> = ({
    compoundVehicleId,
    departure,
    compoundLocation,
}) => (
    <>
        <DetailsRow className="margin-bottom-15">
            <LabelledInfoCell labelMessageId="outboundOrderBook.common.heading.to">
                <DisplayCancellableData isCancelled={departure.isCancelled && departure.departureTo !== undefined}>
                    <AddressDetails
                        address={departure.departureTo?.address ?? {}}
                        identifier={departure.departureTo?.identifier}
                    />
                </DisplayCancellableData>
            </LabelledInfoCell>
        </DetailsRow>
        <DetailsRow className="margin-bottom-15">
            <LabelledInfoCell labelMessageId="outboundOrderBook.compoundManagement.table.heading.carrier">
                <DisplayDepartureFreightForwarder departure={departure} />
            </LabelledInfoCell>
            <LabelledInfoCell labelMessageId="outboundOrderBook.compoundManagement.table.heading.loadId">
                {departure.transportInformation.loadId ? (
                    <DisplayCancellableData isCancelled={departure.isCancelled}>
                        {departure.transportInformation.loadId}
                    </DisplayCancellableData>
                ) : (
                    <NoValue />
                )}
            </LabelledInfoCell>
        </DetailsRow>
        <DepartureCompletedForm
            key={compoundVehicleId}
            timeZone={compoundLocation.timeZone}
            compoundVehicleId={compoundVehicleId}
            meansOfTransportTypeInputDisabled
            disabled={departure.isFinalized || departure.isCancelled}
            departureCompletedAt={departure.departureCompletedAt}
            transportInformation={departure.transportInformation}
        />
    </>
);
